import React, { useEffect, useState } from 'react';
import Modal, { ModalFooter, Prompt } from '@ingka/modal';
import { useSelector } from 'react-redux';
import { hideResumeLastSessionModal, isResumeLastSessionModalOpen } from 'ducks/sheets';
import Button from '@ingka/button';
import styled from 'styled-components';
import Body from 'ui/Typography/Body';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { useSceneHandler } from 'contexts/sceneHandler';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { reportLandingPageSelectStart } from 'analytics/reporters';
import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'routes';
import { useCore } from 'contexts/core';
import { isSpaceEnabled } from 'utils/integration';

const ModalStyles = styled.div`
  width: 100%;
  display: block !important;

  .modal-header .prompt .modal-header__close {
    visibility: hidden;
  }
`;

const ModalWrapper = styled.div`
  .prompt__content-wrapper {
    padding-top: 1.5rem;
  }
`;

function ResumeLastSessionModal() {
  const modalVisible = useSelector(isResumeLastSessionModalOpen);
  const { loadLocalScene } = useSceneHandler();
  const dispatch = useDispatch();
  const history = useHistory();
  const enableSpacePlanning = isSpaceEnabled();
  const coreApi = useCore();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const spacePlanningEnabled = isSpaceEnabled();

  useEffect(() => {
    if (spacePlanningEnabled) return;
    if (modalVisible) {
      setShowModal(true);
      coreApi.kvadratRoom?.toggleRoom(false);
    } else {
      setTimeout(() => {
        coreApi.kvadratRoom?.toggleRoom(true);
        setLoading(false);
        setShowModal(false);
      }, 250);
    }
  }, [coreApi.ipexViewer, coreApi.kvadratRoom, modalVisible, loading, spacePlanningEnabled]);

  const { formatMessage } = useIntl();

  useEffect(() => {
    if (enableSpacePlanning) {
      reportLandingPageSelectStart({ start: 'design_from_scratch' });
      history.replace(AppRoutes.PLANNER_NEW);
      dispatch(hideResumeLastSessionModal());
    }
  }, [dispatch, enableSpacePlanning, history]);

  const onLoadPreviousSolution = () => {
    setLoading(true);
    setTimeout(() => {
      reportLandingPageSelectStart({ start: 'resume_from_last' });
      loadLocalScene();
      dispatch(hideResumeLastSessionModal());
    }, 50);
  };

  const onCreateNew = () => {
    reportLandingPageSelectStart({ start: 'design_from_scratch' });
    history.replace(AppRoutes.PLANNER_NEW);
    dispatch(hideResumeLastSessionModal());
  };

  return (
    <ModalWrapper>
      <Modal
        style={{ zIndex: 1000 }}
        visible={showModal}
        escapable={false}
        handleCloseBtn={() => {}}
      >
        <Prompt
          header={<></>}
          aria-labelledby="GeneratePrompt"
          title={formatMessage({ id: 'storageone.persistedSceneModalResumeDesign' })}
          titleId="resumePreviousDesign"
          footer={
            <ModalFooter>
              <ModalStyles>
                <Button
                  text={formatMessage({
                    id: 'storageone.persistedSceneModalContinueButton'
                  })}
                  type="primary"
                  onClick={onLoadPreviousSolution}
                  data-testid="continue-previous-design"
                  loading={loading}
                />
                <Button
                  text={formatMessage({
                    id: 'storageone.persistedSceneModalCreateNewButton'
                  })}
                  type="secondary"
                  onClick={onCreateNew}
                />
              </ModalStyles>
            </ModalFooter>
          }
        >
          <Body type={ThemeFontStyleTypeEnum.bodyMedium}>
            {formatMessage({ id: 'storageone.persistedSceneModalResumeDesignDescription' })}
          </Body>
        </Prompt>
      </Modal>
    </ModalWrapper>
  );
}

export default ResumeLastSessionModal;
